// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainBefore } from "@insite/client-framework/HandlerCreator";
import { chain, UpdateCart } from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";

const AddAdditionalData: typeof UpdateCart = props => {
    const { editedCartNotes } = props.getState().pages.checkoutShipping;
    const notes = typeof editedCartNotes === "undefined" ? props.apiParameter.cart.notes : editedCartNotes;

    props.apiParameter = {
        ...props.apiParameter,
        cart: {
            ...props.apiParameter.cart,
            notes,
            properties: {
                ...props.apiParameter.cart.properties,
                releaseNumber: (props.parameter as any).releaseNumber,
            },
        },
    };
};

addToChainBefore(chain, UpdateCart, AddAdditionalData);
